import { Form } from '@unform/web';
import { CompactInput, CompactSearch } from 'components/Shared';
import { FindMany } from 'contracts/Common';
import { throttle } from 'lodash';
import React, { useMemo, useState } from 'react';
import * as S from './styles';

export interface EmailLogFilters extends FindMany {
  dateSearch?: string;
}

interface Props {
  onFilter?: (query: EmailLogFilters) => void;
  currentFilter?: EmailLogFilters;
  delay?: number;
}

export const EmailLogFilters: React.FC<Props> = ({
  delay = 1000,
  currentFilter,
  onFilter,
}) => {
  const [filters, setFilters] = useState<EmailLogFilters>({
    ...currentFilter,
    dirty: false,
  });

  const onDateChange = (value: string) => {
    const next = {
      ...filters,
      dirty: true,
      dateSearch: value,
    };

    setFilters(next);
    onFilter?.(next);
  };

  // throttled methods

  const onSearch = useMemo(
    () =>
      throttle((value: string) => {
        const next = {
          ...filters,
          dirty: true,
          search: value,
        };

        setFilters(next);

        onFilter?.(next);
      }, delay),
    [delay, onFilter, filters]
  );

  return (
    <S.Container>
      <Form onSubmit={() => {}}>
        <CompactSearch
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Buscar"
          name="search"
        />
        <S.RightSide>
          <CompactInput
            name="dateSearch"
            type="date"
            onChange={(e) => onDateChange(e.target.value)}
          />
        </S.RightSide>
      </Form>
    </S.Container>
  );
};
